import { isIosDevice } from "src/services/CordovaService/NetworkConnectionService";

interface Properties {
    audioUrl: string | null;
    filename: string | null;
    deleteRecording: () => void;
    openIosFile: () => void;
}

const AudioRecordingRow = ({ audioUrl, filename, deleteRecording, openIosFile }: Properties) => {
    const isIos = isIosDevice();

    if (!audioUrl) {
        return null;
    }

    return (
        <div className="audio-clip">
            {isIos ? (
                <a onClick={openIosFile} className="ios-audio">
                    <svg className="play-icon" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                    </svg>
                    <span className="filename">{filename}</span>
                </a>
            ) : (
                <audio controls={true} src={audioUrl as string} />
            )}
            <button onClick={deleteRecording} className="delete-btn page-input-audio-record-btn" type="button">
                <svg className="trash-icon" viewBox="0 0 24 24">
                    <path d="M9 3a1 1 0 0 0-1 1v1H5.5a1 1 0 1 0 0 2H6v12a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V7h0.5a1 1 0 1 0 0-2H16V4a1 1 0 0 0-1-1H9zm1 4h4v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7z" />
                </svg>
            </button>
        </div>
    );
};

export default AudioRecordingRow;